var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('object',{attrs:{"data":_vm.link,"type":"application/pdf","width":"100%","height":"900px"}},[_c('p',[_vm._v(" Unable to display PDF file. "),_c('a',{attrs:{"href":_vm.link}},[_vm._v("Download")]),_vm._v(" instead. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }